var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 35,
    fill: "url(#pattern0_8_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_8_17",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8_17",
    transform: "matrix(0.00883838 0 0 0.0111111 0.102273 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8_17",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABjElEQVR4nO3cOU7DQBxG8REFEE4AgSOydIRzsIiciKUCLsIiFonqISsuAJnO+Wwm7yelSePx0+g/1bgUSZIkSZKkFQVsAkfALfDG6nkDboBDYGNZkfeAh6HfdETumybL2MlG7o7d385ux4W6HfQZupnJ6nbdZ+jXPx4ieO0zdKeyYlh2B0MvGDrE0CGGDjF0iKFDDB1i6BBDhxg6xNAhhg4xdIihQwwdYugQQ4cYOsTQIYYOMXSIoUMMHWLoEEOHGDrE0CGGDjF0iKFDDB1i6BBDhxg6xNC1h9aCoUMMHVJb6E/gGJi2v1n73+BqCz3rWFcTe3C1hd7pWNc2lYUewxXlace6dodeFPBS26X7Wce6Tmq7dN98cWVon+1MHtthuN9n6I32IyD66Q5Y7y30t0/9GPtn5N1eI//a2QfNXBrJAZnWvPNVMy5638mSJEn/D7AFXADPDOcJOAcmpVbAnPGYlxoBa8AH4/HerKnUBkOv7Oi4LLUCJsBZeyAN5RE4rfowlCRJkiRJKsv1BcszuUtLy0MnAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.a28c389f3a55f8f5e197e70be36281f4.svg";
export { ForwardRef as ReactComponent };